import Vue from 'vue'
import VueQuillEditor  from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
// import Quill from 'quill';
// import ImageResize from 'quill-image-resize-module'; // 引用
// Quill.register('modules/imageResize', ImageResize); // 注册
// import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import iView from 'iview'
import 'iview/dist/styles/iview.css'    // 使用 CSS
Vue.config.productionTip = false
Vue.use(iView)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js